import ParticipantWrapper from "@/elements/participant-wrapper"
import { EParticipantWrapperSize } from "@/elements/participant-wrapper/ParticipantWrapper"
import { StakeHolderSurvey } from "@/features/stake-holder-survey"
import { SimpleLayout } from "@/layouts"

const StakeHolderSurveyPage = () => {
    return (
        <SimpleLayout
            withProfileHeader
            withoutHeader
            isSimpleHeader
            withFooter={false}
            mainClassName="flex justify-center"
        >
            <ParticipantWrapper size={EParticipantWrapperSize.MaxMedium}>
                <StakeHolderSurvey />
            </ParticipantWrapper>
        </SimpleLayout>
    )
}

export default StakeHolderSurveyPage
